import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { heroFontFamily } from "./heroFont"

const useStyles = makeStyles()((theme) => ({
    title: {
        fontFamily: heroFontFamily,
        fontSize: "2.5rem",
        fontWeight: 600,
        lineHeight: 1.1,
        color: theme.palette.tailwind.slate[900],
    },
    subtitle: {
        maxWidth: "36rem",
        color: theme.palette.tailwind.slate[500],
    },
}))

export function TenantUsageHeader() {
    const { classes } = useStyles()

    return (
        <Stack gap=".5rem">
            <LocalizedStrict id="service-center-usage-per-tenant-header-title">
                <Typography component="h1" className={classes.title}>
                    Usage by tenant
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="service-center-usage-per-tenant-header-subtitle">
                <Typography variant="body1" className={classes.subtitle}>
                    How each tenant draws on shared resources across your service center.
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
